import { render } from "./Product.vue?vue&type=template&id=5537531e"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"
script.render = render

export default script